import React, { useEffect, useState } from 'react'

import CarPlaceholder from '../../../../../assets/car-placeholder.png'

import './index.scss'

const CarAvailability = ({ threadDetails, firstMessage }) => {
    const [availability, setAvailability] = useState({})

    useEffect(() => {
        if (!firstMessage || !threadDetails) {
            return
        }

        if (!threadDetails.rawResponse) {
            return
        }

        const { Available } = threadDetails.rawResponse

        if (firstMessage.ThreadId !== '--') {
            setAvailability({
                vehicle: firstMessage.Vehicle,
                message: Available ? 'Available' : 'Not Available',
                color: Available ? 'green' : 'red',
            })

            return
        }

        setAvailability({
            vehicle: firstMessage.Vehicle,
            message: 'No VIN',
            color: 'red',
        })
    }, [firstMessage, threadDetails])

    return (
        <div className='CarAvailability'>
            <div
                className='CarAvailability__image'
                style={{
                    backgroundImage: `url(${
                        (threadDetails.photos && threadDetails.photos[0])
                        || CarPlaceholder
                    })`,
                }}
            ></div>
            <div className='right-side'>
                {availability && (
                    <p
                        className='CarAvailability__status'
                        style={{ color: availability.color }}
                    >
                        {availability.message}
                    </p>
                )}

                {availability.vehicle && (
                    <p className='CarAvailability__vehicle'>
                        {availability.vehicle}
                    </p>
                )}

                <div className='CarAvailability__price'>
                    <p>Sale Price</p>
                    <p>{threadDetails.price}</p>
                </div>
                <div className='CarAvailability__msrp'>
                    <p>MSRP</p> <div>${threadDetails.msrp}</div>
                </div>
            </div>
        </div>
    )
}

export default CarAvailability
